import { Text, Image } from '@belong/ui';

type TourHostTileProps = {
  profileImageUrl: string;
  firstName: string;
  lastName: string;
};

export function TourHostTile({
  profileImageUrl,
  firstName,
  lastName,
}: TourHostTileProps) {
  return (
    <div className="mt-lg flex">
      <div className="relative mr-xs h-xl w-xl overflow-hidden rounded-full border-2 border-solid border-navy bg-green">
        <div
          className="absolute left-1/2 h-2xl w-2xl -translate-x-1/2"
          style={{ top: 2 }}
        >
          <Image src={profileImageUrl} className="object-cover" alt="" />
        </div>
      </div>

      <div>
        <Text variant="p1">Hosted By</Text>
        <Text fontWeight="semibold">
          {firstName} {lastName}
        </Text>
      </div>
    </div>
  );
}
